import React from 'preact/compat';

const XIcon: React.FC<{ size?: number }> = ({ size = 24 }) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width={size}
    height={size}
    viewBox='0 0 24 24'
    fill='none'
    stroke='currentColor'
    strokeWidth='2'
    strokeLinecap='round'
    strokeLinejoin='round'
  >
    <line
      x1='18'
      y1='6'
      x2='6'
      y2='18'
    ></line>
    <line
      x1='6'
      y1='6'
      x2='18'
      y2='18'
    ></line>
  </svg>
);

export default XIcon;
